/**
 * Classic B: brick chambers, each plugged by a boulder (docs/spec/03 §2). A plug with space behind
 * it can be pushed in; a plug with a diamond behind it has to be dug out from below so it rolls.
 * The approach to the exit is fixed dirt: a random boulder in that one-high corridor could seal it.
 */

import type { CaveDef } from '../types';

export const caveB: CaveDef = {
  id: 'B',
  name: 'CHAMBERS',
  hint: 'Every chamber has a way in. Some push, some roll.',
  intermission: false,
  colors: [9, 15, 7],
  diamondValue: 10,
  extraValue: 20,
  fill: { base: '.', items: [['r', 12], ['d', 3]] },
  levels: [
    { seed: 1201, diamonds: 15, time: 150 },
    { seed: 1202, diamonds: 18, time: 145 },
    { seed: 1203, diamonds: 21, time: 140 },
    { seed: 1204, diamonds: 24, time: 130 },
    { seed: 1205, diamonds: 27, time: 120 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'WP...??????????????????????????????????W',
    'W....??????????????????????????????????W',
    'W??wwwwwww??wwwwwww??wwwwwww??wwwwwww??W',
    'W??wd?r?dw??w?d?d?w??w?d?d?w??wd?r?dw??W',
    'W??w??d??w??w???r?w??w?r???w??w??d??w??W',
    'W??w?d?d?w??w?d?ddr..rdd?d?w??w?d?d?w??W',
    'W??w.....w??w??r??w..w??r??w??w.....w??W',
    'W?.r  .d.w??w?d?d?w??w?d?d?w??w.d.  r.?W',
    'W?.wwwwwww??wwwwwww??wwwwwww??wwwwwww??W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??wwwwwww??wwwwwww??wwwwwww??wwwwwww??W',
    'W??w?d?d?w??w?d?d?w??w?d?d?w??wd?r?dw??W',
    'W??w?r???w??w?rdr?w??w?rdr?w??w??d??w??W',
    'W?.rdd?d?w?.rd?d??w??w??d?dr.?w?d?d?w??W',
    'W?.w??r??w?.w??...w??w...??w.?w.....w??W',
    'W??w?d?d?w??w?d.  r..r  .d?w?.r  .d.w??W',
    'W??wwwwwww??wwwwwww??wwwwwww??wwwwwww..W',
    'W???????????????????????????........X..W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
